import React from 'react'
import FaqAccordion from './FaqAccordion'
import { useLocation } from 'react-router-dom';
import { faqs, pricingFaqs } from '../../../../utilities/constants';


const Faq = () => {
    const location = useLocation();

   return (
        <div className='flex flex-col w-full'>
            {pricingFaqs.map(({ question, answer }, index) => (
                <FaqAccordion title={question} key={index} index={index} length={pricingFaqs?.length} content={answer}/>
            ))}
        </div>
    )
}

export default Faq
